<template>
    <div>
        <el-upload v-show="!currentFile" class="video-upload" action="#" :auto-upload="false" ref="vupload"
            :show-file-list="false" :on-change="handleChange" drag :before-upload="beforeUpload"
            :http-request="customRequest" accept="video/*,application/pdf,.pdf" :multiple="false">
            <template>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传视频或PDF文件，视频不超过1G</div>
            </template>

        </el-upload>
        <div v-if="currentFile"
            style="border: 1px dashed #d9d9d9;  border-radius: 6px;width:360px;box-sizing: border-box;line-height: 30px;">
            <div class="progress-container">
                <el-progress type="circle" :percentage="progress.percent" :status="progress.status" />
                <div class="progress-info">
                    <p>{{ currentFile.name }}({{ getSizeMb(currentFile.size) }})</p>
                    <p>{{ progress.text }}</p>
                </div>
                <el-button v-if="isNeedUp&&!isUploading" size="small" type="success" @click="submitUpload">{{
                    aborted ? '重新上传' : '点击上传' }}</el-button>
                <el-button v-if="isUploading" size="small" type="danger" @click="abortUpload">中止上传</el-button>
                <el-button v-else size="small" type="warning" @click="resetUpload">重选文件</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import OSS from 'ali-oss'
import pdf from 'vue-pdf' // 用于解析 PDF 页数
// import { v4 as uuidv4 } from 'uuid'

export default {
    data() {
        return {
            progress: {
                percent: 0,
                visible: false,
                text: '等待用户点击上传...',
                status: null
            },
            isNeedUp: false,
            isUploading: false,
            activeUpload: null,
            checkpoint: null,
            currentFile: null,
            client: null,
            aborted: false, // 本次上传是否被用户中止
        }
    },

    methods: {
        handleChange(file) {
            // 单文件模式:el-upload 内部 handleStart 是 push 而不是替换,
            // 不清掉旧文件的话提交时会把上一个文件一起上传
            this.clearOtherFiles(file)
            this.currentFile = file
            // 只有真正选了新文件(ready)才算重新选择,按钮文案回到"点击上传";
            // 上传成功/失败回调也会走到这里,不能把"继续上传"的文案重置掉
            if (file.status === 'ready') this.aborted = false
            if (this.progress.status !== 'success') {
                this.isNeedUp = true
                // 视频读取时长;PDF 等资料无时长,直接回传 0
                if (file.raw.type && file.raw.type.startsWith('video/')) {
                    const video = document.createElement('video');
                    video.preload = 'metadata';
                    video.src = URL.createObjectURL(file.raw);

                    video.onloadedmetadata = () => {
                        this.$emit('setFormTimeForKey', video.duration ? Math.floor(video.duration) : 0)
                        URL.revokeObjectURL(video.src); // 释放内存
                    };
                } else {
                    // PDF 等资料:解析页数写入时长字段(视频时长秒 / PDF 页数)
                    this.resolvePdfPages(file)
                }
            }
        },
        async resolvePdfPages(file) {
            let url = ''
            try {
                url = URL.createObjectURL(file.raw)
                const task = pdf.createLoadingTask(url)
                const pdfDoc = await task.promise
                this.$emit('setFormTimeForKey', pdfDoc.numPages || 0)
            } catch (e) {
                this.$emit('setFormTimeForKey', 0)
            } finally {
                if (url) URL.revokeObjectURL(url)
            }
        },
        getSizeMb(size) {
            return (size / 1024 / 1024).toFixed(2) + 'MB'
        },
        resetUpload() {
            this.progress = {
                percent: 0,
                visible: false,
                text: '等待用户点击上传...',
                status: null
            }
            this.currentFile = null
            this.isNeedUp = true
            this.checkpoint = null
            this.aborted = false
            // 清掉 el-upload 内部的文件列表,否则重新选择文件后会把上一个文件一起提交
            if (this.$refs.vupload) this.$refs.vupload.clearFiles()
            this.$emit('setFormValForKey', '')
        },
        submitUpload() {
            this.$refs.vupload.submit();
        },
        beforeUpload(file) {
            const isVideo = file.type.startsWith('video/')
            const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name)
            const isLt1G = file.size / 1024 / 1024 / 1024 < 1

            if (!isVideo && !isPdf) {
                this.$message.error('只能上传视频或PDF文件!')
                return false
            }
            if (!isLt1G) {
                this.$message.error('文件大小不能超过1G!')
                return false
            }
            return true
        },
        async customRequest(options) {
            try {
                this.aborted = false
                this.progress = {
                    percent: 0,
                    visible: true,
                    text: '正在初始化上传...',
                    status: null
                }
                this.isUploading = true
                // 初始化OSS客户端
                this.client = new OSS({
                    accessKeyId: 'LTAI5tCKn77oWs8eyc1h1JXb',
                    accessKeySecret: 'DzuZXejhleoBRBifUi3SBIDE7WUYZK',
                    bucket: 'xixun-dianbo',
                    region: 'oss-cn-shanghai',
                    secure: true
                })
                const file = options.file
                const fileName = `${file.name.slice(0, file.name.lastIndexOf('.'))}-${new Date().getTime()}${file.name.slice(file.name.lastIndexOf('.'))}`
                // 执行分片上传
                this.activeUpload = this.client.multipartUpload(fileName, file, {
                    partSize: 5 * 1024 * 1024, // 5MB分片
                    parallel: 3, // 并发数
                    checkpoint: this.checkpoint,
                    progress: (percentage, checkpoint) => {
                        // 已中止:忽略后续进度(后台的流可能还会跑一小会儿)
                        if (this.aborted) return
                        this.checkpoint = checkpoint
                        // 同步进度给 el-upload,让它的文件状态真正变成 uploading(中止时才好恢复成 ready)
                        options.onProgress({ percent: Math.floor(percentage * 100) })
                        this.progress = {
                            percent: Math.floor(percentage * 100),
                            visible: true,
                            text: this.getProgressText(percentage),
                            status: null
                        }
                    }
                })
                const result = await this.activeUpload
                // 已被用户中止:丢弃本次结果,不写表单也不提示成功
                if (this.aborted) return
                result.res.size = file.size
                console.debug('upload success: %j', result);
                this.handleSuccess(result)
                // 通知 el-upload 把该文件置为 success,否则它一直认为还在 uploading
                options.onSuccess(result)
            } catch (err) {
                // 用户主动中止:ali-oss 会抛出 cancel({status:0,name:'cancel'}),这不是失败。
                // 注意不能正常 return:el-upload 的 post() 里有 req.then(options.onSuccess, options.onError),
                // 一旦 resolve 就会被当成"上传成功",把文件标成 success 并触发 onChange,
                // 结果按钮文案被重置、文件也不再是 ready,"继续上传"就传不动了。
                // 所以这里返回一个永不 resolve 的 promise,让 el-upload 不要动这个文件。
                if (this.aborted) {
                    this.progress.text = '已中止上传'
                    this.progress.status = 'exception'
                    return new Promise(() => { })
                }
                console.error('上传失败:', err)
                if (err && err.status == 0) {
                    this.progress.text = '上传已取消'
                    this.progress.status = 'exception'
                    // this.$message.warning('上传已中止')
                } else {
                    this.progress.status = 'exception'
                    this.progress.text = '上传失败'
                    this.$message.error('文件上传失败')
                }
                // 恢复成 ready,否则再次点击上传时 submit() 过滤不到文件
                this.markFileReady()
                // if(){

                // }

            } finally {
                setTimeout(() => {
                    this.progress.visible = false
                }, 3000)
            }
        },
        async abortUpload() {
            this.isUploading = false;
            this.aborted = true
            // 中止后必须恢复成 ready:el-upload 的 submit() 只提交 status==='ready' 的文件,
            // 不恢复的话再点"点击上传"会没反应
            this.markFileReady()
            this.progress.text = '已中止上传'
            this.progress.status = 'exception'
            // 服务端分片要被删掉,续传点也必须清掉:否则"继续上传"会拿失效的 uploadId 走断点续传而失败
            let checkpoint = this.checkpoint
            this.checkpoint = null
            try {
                if (!this.client) return
                // 停掉在途的分片上传流(ali-oss 的 cancel 挂在 client 上)
                this.client.cancel()
                // 删掉已上传的分片(checkpoint 里的 name/uploadId 才是本次上传的)
                if (checkpoint && checkpoint.uploadId && checkpoint.name) {
                    await this.client.abortMultipartUpload(checkpoint.name, checkpoint.uploadId)
                }
            } catch (e) {
                console.error('中止上传失败:', e)
            }
        },
        // 把 el-upload 内部处于 uploading 的文件恢复为 ready
        markFileReady() {
            if (!this.$refs.vupload) return
            let files = this.$refs.vupload.uploadFiles || []
            files.forEach(file => {
                if (file.status === 'uploading') file.status = 'ready'
            })
        },
        // 只保留当前选中的文件(组件是单文件上传)
        clearOtherFiles(file) {
            if (!this.$refs.vupload || !file) return
            let files = this.$refs.vupload.uploadFiles || []
            for (let i = files.length - 1; i >= 0; i--) {
                if (files[i].uid !== file.uid) files.splice(i, 1)
            }
        },
        handleSuccess(result) {
            this.$emit('setFormValForKey', result)
            this.isNeedUp = false
            this.isUploading = false
            this.progress.status = 'success'
            this.progress.text = '上传成功'
        },
        getProgressText(percentage) {
            const progress = Math.floor(percentage * 100)
            return `已上传 ${progress}% (${this.formatFileSize(
                this.currentFile.size * percentage
            )}/${this.formatFileSize(this.currentFile.size)})`
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 B'
            const k = 1024
            const sizes = ['B', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`
        }
    }
}
</script>

<style scoped lang="less">
.progress-container {
    text-align: center;
    padding: 20px;
}

.progress-info {
    margin-bottom: 10px;
    font-size: 14px;
    color: #666;
}

/deep/.el-upload-dragger {
    min-height: 180px;
    height: auto;
}

.video-upload {
    line-height: 20px;
}
</style>